import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};
var iniChannel;
var iniLocation;
var iniCampaign;

class ActivityEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);
        
        var data = props.Daatta.filter(function (d) {
            return d.activityId === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            ActivityId: data[0].activityId,
            Name: data[0].name,
            Description: data[0].description,
            Owner: data[0].owner,
            Channel_Id: data[0].channel_Id,
            Location_Id: data[0].location_Id,
            Campaign_Id: data[0].campaign_Id,
            ExternalLink: data[0].externalLink,
            PublishTime: data[0].publishTime,
            Modifier: data[0].modifier,
            StartTime: data[0].startTime,
            EndTime: data[0].endTime,
            channel: (Object.keys(props.lookupLists.channel).map((d) => ({ value: d, label: props.lookupLists.channel[d] })) || []),
            location: (Object.keys(props.lookupLists.location).map((d) => ({ value: d, label: props.lookupLists.location[d] })) || []),
            campaign: (Object.keys(props.lookupLists.campaign).map((d) => ({ value: d, label: props.lookupLists.campaign[d] })) || []),
        };

    }

    UNSAFE_componentWillMount() {
        iniChannel = this.state.channel.find(({ value }) => value === (this.state.Channel_Id || '').toString());
        iniLocation = this.state.location.find(({ value }) => value === (this.state.Location_Id || '').toString());
        iniCampaign = this.state.campaign.find(({ value }) => value === (this.state.Campaign_Id || '').toString());
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            ActivityId: this.state.data[0].activityId,
            Name: this.state.data[0].name,
            Description: this.state.data[0].description,
            Owner: this.state.data[0].owner,
            Channel_Id: this.state.data[0].channel_Id,
            Location_Id: this.state.data[0].location_Id,
            Campaign_Id: this.state.data[0].campaign_Id,
            ExternalLink: this.state.data[0].externalLink,
            PublishTime: this.state.data[0].publishTime,
            Modifier: this.state.data[0].modifier,
            StartTime: this.state.data[0].startTime,
            EndTime: this.state.data[0].endTime
            
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            ActivityId: this.state.ActivityId,
            Name: this.state.Name,
            Description: this.state.Description,
            Owner: this.state.Owner,
            Channel_Id: this.state.Channel_Id,
            Location_Id: this.state.Location_Id,
            Campaign_Id: this.state.Campaign_Id,
            ExternalLink: this.state.ExternalLink,
            PublishTime: this.state.PublishTime,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime

        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, channel, location, campaign } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Activity.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Activity.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Activity.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Description}
                            onChange={this.handleChange('Description')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Activity.Columns[3]}
                            type="text"
                            fullWidth
                            value={this.state.Owner}
                            onChange={this.handleChange('Owner')}
                        />
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniChannel}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Channel_Id')}
                                options={channel}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Activity.Columns[4]} />}
                            />
                        </Box>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniLocation }
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Location_Id')}
                                options={location}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Activity.Columns[5]} />}
                            />
                        </Box>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniCampaign }
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Campaign_Id')}
                                options={campaign}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Activity.Columns[6]} />}
                            />
                        </Box>
                       
                        <TextField
                            margin="dense"
                            label={dictionary.Activity.Columns[7]}
                            type="text"
                            fullWidth
                            value={this.state.ExternalLink}
                            onChange={this.handleChange('ExternalLink')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Activity.Columns[8]}
                            type="text"
                            fullWidth
                            value={this.state.PublishTime}
                            onChange={this.handleChange('PublishTime')}
                        />
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />

            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "ActivityEdit" })(ActivityEdit);
